import { render, staticRenderFns } from "./MerchantPromoFilter.vue?vue&type=template&id=80a650fc"
import script from "./MerchantPromoFilter.vue?vue&type=script&lang=js"
export * from "./MerchantPromoFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports